import React, { useState } from "react";
import GearCard from "./GearCard";
import { equipmentProducts } from "./GearData";
import "./GearsSection.css";

const GearSection = () => {
  const [activeTab, setActiveTab] = useState("CAMERAS");

  // Get all unique categories for tabs
  const categories = [
    ...new Set(equipmentProducts.map((category) => category.category)),
  ];

  // Filter products based on active tab
  const activeProducts =
    equipmentProducts.find((category) => category.category === activeTab)
      ?.items || [];

  return (
    <section className="gear-section" id="gear-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Equipment Rental</h2>
          <p className="section-subtitle">
            High-quality gear for your production needs
          </p>
        </div>

        {/* Category Tabs */}
        <div className="tabs-container">
          <div className="horizontal-tabs">
            {categories.map((category) => (
              <button
                key={category}
                className={`tab-btn ${activeTab === category ? "active" : ""}`}
                onClick={() => setActiveTab(category)}
              >
                {formatCategoryName(category)}
              </button>
            ))}
          </div>
        </div>

        {/* Products Grid */}
        <div className="gear-grid">
          {activeProducts.map((product) => (
            <GearCard
              key={product.code}
              imageUrl={product.image}
              category={formatCategoryName(activeTab)}
              productName={product.title}
              details={product.description}
              ratePerDay={product.rate}
              rating={product.rating || 4.5}
              isFeatured={product.isFeatured || false}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

// Helper function to format category names
const formatCategoryName = (category) => {
  return category
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\b\w/g, (l) => l.toUpperCase()); // Capitalize first letters
};

export default GearSection;
